module.exports = __webpack_public_path__ + "img/exhibits2.46ab2a1a.png";